<div class="content-area">
    <div
        class="container search-area"
        fxFlex="100"
        fxLayout="row"
        fxLayoutAlign="center start"
        fxFlexFill
    >
        <app-provider-search
            fxFlex="940px"
            fxFlex.lt-md="90%"
            fxFlexFill
            (searchEvent)="searchProviders($event)"
            [formattedSearchAddress]="formattedSearchAddress"
        ></app-provider-search>
    </div>
</div>

<div class="content-area">
    <div
        class="container results-area"
        fxFlex="940px"
        fxFlex.lt-md="90%"
        fxFlexFill
    >
        <app-provider-card-collection
            [providers]="providers"
            [filtered]="searchParams.filtered"
            [loading]="(loading$ | async) ?? false"
            (sortEvent)="sortProviders($event)"
        ></app-provider-card-collection>
    </div>
</div>
